import ThemeMostPopular1 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-mostpopular-1.webp';
import ThemeMostPopular2 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-mostpopular-2.webp';
import ThemeMostPopular3 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-mostpopular-3.webp';
import ThemeMostPopular4 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-mostpopular-4.webp';
import ThemeMostPopular5 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-mostpopular-5.webp';
import ThemeMostPopular6 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-mostpopular-6.webp';

import ThemeGreenery1 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-greenery-1.webp';
import ThemeGreenery2 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-greenery-2-updated.webp';
import ThemeGreenery3 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-greenery-3.webp';
import ThemeGreenery4 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-greenery-4.webp';
import ThemeGreenery5 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-greenery-5.webp';
import ThemeGreenery6 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-greenery-6.webp';

import ThemeFloral1 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-floral-1.webp';
import ThemeFloral2 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-floral-2.webp';
import ThemeFloral3 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-floral-3.webp';
import ThemeFloral4 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-floral-4.webp';
import ThemeFloral5 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-floral-5.webp';
import ThemeFloral6 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-floral-6.webp';

import ThemeModern1 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-modern-1.webp';
import ThemeModern2 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-modern-2.webp';
import ThemeModern3 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-modern-3.webp';
import ThemeModern4 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-modern-4.webp';
import ThemeModern5 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-modern-5.webp';
import ThemeModern6 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-modern-6.webp';

import ThemeRustic1 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-rustic-1-updated.webp';
import ThemeRustic2 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-rustic-2.webp';
import ThemeRustic3 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-rustic-3.webp';
import ThemeRustic4 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-rustic-4.webp';
import ThemeRustic5 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-rustic-5.webp';
import ThemeRustic6 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-rustic-6-updated.webp';

import ThemeClassic1 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-classic-1.webp';
import ThemeClassic2 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-classic-2.webp';
import ThemeClassic3 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-classic-3.webp';
import ThemeClassic4 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-classic-4.webp';
import ThemeClassic5 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-classic-5.webp';
import ThemeClassic6 from '../../../../../public/static-preauth/images/WeddingWebsiteLP/V3/Themes/theme-classic-6.webp';

export type ThemeTileProps = {
  href: string;
  imgAlt: string;
  imgSrc: string;
  previewIdentifier: {
    layout: string;
    themeKey: string;
  };
};

const MULTI_PAGE = 'MULTI_PAGE';
const SINGLE_PAGE = 'SINGLE_PAGE';

const WEBSITE_DESIGN_PATH = '/wedding-planning/website/design';
const WEBSITE_DESIGNS_PATH = '/wedding-planning/website/designs';

const MOST_POPULAR_THEME_TILES: ThemeTileProps[] = [
  {
    href: `${WEBSITE_DESIGN_PATH}/galata?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola most popular theme',
    imgSrc: ThemeMostPopular1,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'galata',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/octavia-purple?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola second most popular theme',
    imgSrc: ThemeMostPopular2,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'octavia-purple',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/essenza-white?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola third most popular theme',
    imgSrc: ThemeMostPopular3,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'essenza-white',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/avila-light-greige?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fourth most popular theme',
    imgSrc: ThemeMostPopular4,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'avila-light-greige',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/violin?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola fifth most popular theme',
    imgSrc: ThemeMostPopular5,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'violin',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/latona-charcoal?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola sixth most popular theme',
    imgSrc: ThemeMostPopular6,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'latona-charcoal',
    },
  },
];

const GREENERY_THEME_TILES: ThemeTileProps[] = [
  {
    href: `${WEBSITE_DESIGN_PATH}/farnham-green?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola greenery theme',
    imgSrc: ThemeGreenery1,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'farnham-green',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/oxley-smoke?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola second greenery theme',
    imgSrc: ThemeGreenery2,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'oxley-smoke',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/eastwick?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola third greenery theme',
    imgSrc: ThemeGreenery3,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'eastwick',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/anaheim-white?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fourth greenery theme',
    imgSrc: ThemeGreenery4,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'anaheim-white',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/somerset-white?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola fifth greenery theme',
    imgSrc: ThemeGreenery5,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'somerset-white',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/cabo-beige?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola sixth greenery theme',
    imgSrc: ThemeGreenery6,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'cabo-beige',
    },
  },
];

const FLORAL_THEME_TILES: ThemeTileProps[] = [
  {
    imgSrc: ThemeFloral1,
    href: `${WEBSITE_DESIGN_PATH}/goundry-dark-emerald?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola floral theme',
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'goundry-dark-emerald',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/merryton-forest?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola second floral theme',
    imgSrc: ThemeFloral2,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'merryton-forest',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/windsong-off-white?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola third floral theme',
    imgSrc: ThemeFloral3,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'windsong-off-white',
    },
  },
  {
    imgSrc: ThemeFloral4,
    href: `${WEBSITE_DESIGN_PATH}/caleania-bright-sage?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fourth floral theme',
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'caleania-bright-sage',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/maywood-plum?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola fifth floral theme',
    imgSrc: ThemeFloral5,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'maywood-plum',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/monahan-linen?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola sixth floral theme',
    imgSrc: ThemeFloral6,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'monahan-linen',
    },
  },
];

const MODERN_THEME_TILES: ThemeTileProps[] = [
  {
    href: `${WEBSITE_DESIGN_PATH}/pinellas-onyx?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola modern theme',
    imgSrc: ThemeModern1,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'pinellas-onyx',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/brevard-periwinkle?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola second modern theme',
    imgSrc: ThemeModern2,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'brevard-periwinkle',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/coleridge-white?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola third modern theme',
    imgSrc: ThemeModern3,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'coleridge-white',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/santini-dusty-blue?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fourth modern theme',
    imgSrc: ThemeModern4,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'santini-dusty-blue',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/verne-beige?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola fifth modern theme',
    imgSrc: ThemeModern5,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'verne-beige',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/rafina-peach-blush?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola sixth modern theme',
    imgSrc: ThemeModern6,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'rafina-peach-blush',
    },
  },
];

const RUSTIC_THEME_TILES: ThemeTileProps[] = [
  {
    href: `${WEBSITE_DESIGN_PATH}/kelton-cream?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola rustic theme',
    imgSrc: ThemeRustic1,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'kelton-cream',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/saranac-dark-wood?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola second rustic theme',
    imgSrc: ThemeRustic2,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'saranac-dark-wood',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/sylvan-ivory?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola third rustic theme',
    imgSrc: ThemeRustic3,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'sylvan-ivory',
    },
  },
  {
    imgSrc: ThemeRustic4,
    href: `${WEBSITE_DESIGN_PATH}/millbrook-deep-blue-spruce?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fourth rustic theme',
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'millbrook-deep-blue-spruce',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/humboldt-black?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fifth rustic theme',
    imgSrc: ThemeRustic5,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'humboldt-black',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/carroway-blue-sage?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola sixth rustic theme',
    imgSrc: ThemeRustic6,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'carroway-blue-sage',
    },
  },
];

const CLASSIC_THEME_TILES: ThemeTileProps[] = [
  {
    href: `${WEBSITE_DESIGN_PATH}/zortas-dusty-blue?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola classic theme',
    imgSrc: ThemeClassic1,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'zortas-dusty-blue',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/eldridge-dark-olive?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola second classic theme',
    imgSrc: ThemeClassic2,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'eldridge-dark-olive',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/seibert-ebony?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola third classic theme',
    imgSrc: ThemeClassic3,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'seibert-ebony',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/eyota-white?layout=${SINGLE_PAGE}`,
    imgAlt: 'Zola fourth classic theme',
    imgSrc: ThemeClassic4,
    previewIdentifier: {
      layout: SINGLE_PAGE,
      themeKey: 'eyota-white',
    },
  },
  {
    imgSrc: ThemeClassic5,
    href: `${WEBSITE_DESIGN_PATH}/creston-dark-charcoal?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola fifth classic theme',
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'creston-dark-charcoal',
    },
  },
  {
    href: `${WEBSITE_DESIGN_PATH}/paltz-greige?layout=${MULTI_PAGE}`,
    imgAlt: 'Zola sixth classic theme',
    imgSrc: ThemeClassic6,
    previewIdentifier: {
      layout: MULTI_PAGE,
      themeKey: 'paltz-greige',
    },
  },
];

export const ALL_THEME_MOTIFS = [
  {
    label: 'Most popular',
    key: 'mostPopular',
    themeMotifHref: WEBSITE_DESIGNS_PATH,
    tiles: MOST_POPULAR_THEME_TILES,
  },
  {
    label: 'Greenery',
    key: 'greenery',
    themeMotifHref: `${WEBSITE_DESIGNS_PATH}?motifs=GREENERY`,
    tiles: GREENERY_THEME_TILES,
  },
  {
    label: 'Floral',
    key: 'floral',
    themeMotifHref: `${WEBSITE_DESIGNS_PATH}?motifs=FLORAL`,
    tiles: FLORAL_THEME_TILES,
  },
  {
    label: 'Modern',
    key: 'modern',
    themeMotifHref: `${WEBSITE_DESIGNS_PATH}?motifs=MODERN`,
    tiles: MODERN_THEME_TILES,
  },
  {
    label: 'Rustic',
    key: 'rustic',
    themeMotifHref: `${WEBSITE_DESIGNS_PATH}?motifs=RUSTIC`,
    tiles: RUSTIC_THEME_TILES,
  },
  {
    label: 'Classic',
    key: 'classic',
    themeMotifHref: `${WEBSITE_DESIGNS_PATH}?motifs=CLASSIC_TRADITIONAL`,
    tiles: CLASSIC_THEME_TILES,
  },
];
